import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=452154a2&"
import script from "./Warehouses.vue?vue&type=script&lang=ts&"
export * from "./Warehouses.vue?vue&type=script&lang=ts&"
import style0 from "./Warehouses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports